import { BrandfolderHexColors } from '../enums/colors.js';
import { errorAlert, defaultAlert, successAlert, warningAlert, errorAlertDark, defaultAlertDark, successAlertDark, warningAlertDark } from './alert.js';
import { dangerButton, blackButton, primaryButton, secondaryButton, tertiaryButton, textSecondaryButton, textTertiaryButton, textWarningButton, warningButton, whiteButton } from './button.js';
import { defaultCheckboxLight } from './checkbox.js';
import { defaultDividerLight, primaryDividerLight, defaultDividerDark, primaryDividerDark } from './divider.js';
import { defaultDropdownLight, defaultDropdownPrimary } from './dropdown.js';
import { defaultFieldsetLight, defaultFieldsetDark } from './fieldset.js';
import { fontFamilyBold, fontFamilyBook, fontFamilyMedium, fontSizeLarge, fontSizeMedium, fontSizeSmall, fontSizeXLarge, fontSizeXSmall, fontSizeXxSmall, fontSizeXxLarge, fontWeightBold, fontWeightBook, fontWeightMedium } from './fonts.js';
import { defaultInputLight } from './input.js';
import { defaultListLight, defaultListPrimary } from './list.js';
import { defaultListboxLight, defaultListboxDark } from './listbox.js';
import { blackLoader, grayLoader, primaryLightLoader, warningLoader, whiteLoader, defaultLightShimmerLoader, primaryDarkLoader } from './loader.js';
import { defaultOptionLight, defaultOptionDark } from './option.js';
import { outlineOffset, outlineWidth } from './outlines.js';
import { defaultPopout, primaryPopout } from './popout.js';
import { defaultRadioLight } from './radio.js';
import { defaultSwitchLight } from './switch.js';
import { defaultTableLight, defaultTableDark } from './table.js';
import { dangerTooltip, defaultTooltip, primaryTooltip } from './tooltip.js';

const baseTheme = {
    alert: {
        error: errorAlert,
        none: defaultAlert,
        success: successAlert,
        warning: warningAlert
    },
    button: {
        danger: dangerButton,
        default: blackButton,
        primary: primaryButton,
        secondary: secondaryButton,
        tertiary: tertiaryButton,
        ['text-secondary']: textSecondaryButton,
        ['text-tertiary']: textTertiaryButton,
        ['text-warning']: textWarningButton,
        warning: warningButton,
        white: whiteButton
    },
    checkbox: {
        default: defaultCheckboxLight
    },
    divider: {
        default: defaultDividerLight,
        primary: primaryDividerLight
    },
    dropdown: {
        default: defaultDropdownLight,
        primary: defaultDropdownPrimary
    },
    fieldset: {
        default: defaultFieldsetLight
    },
    font: {
        families: {
            bold: fontFamilyBold,
            book: fontFamilyBook,
            medium: fontFamilyMedium
        },
        sizes: {
            large: fontSizeLarge,
            medium: fontSizeMedium,
            small: fontSizeSmall,
            xlarge: fontSizeXLarge,
            xsmall: fontSizeXSmall,
            xxsmall: fontSizeXxSmall,
            xxlarge: fontSizeXxLarge
        },
        weights: {
            bold: fontWeightBold,
            book: fontWeightBook,
            medium: fontWeightMedium
        }
    },
    input: {
        default: defaultInputLight
    },
    loader: {
        black: blackLoader,
        gray: grayLoader,
        primary: primaryLightLoader,
        warning: warningLoader,
        white: whiteLoader
    },
    link: {
        outlineColorFocus: '#4462C9',
        textColor: '#4462C9',
        textColorActive: '#364EA3',
        textColorDisabled: '#BCBCBC',
        textColorFocus: '#1D3163',
        textColorHover: '#1D3163',
        textColorVisited: '#4462C9'
    },
    list: {
        default: defaultListLight,
        primary: defaultListPrimary
    },
    listbox: {
        default: defaultListboxLight
    },
    option: {
        default: defaultOptionLight
    },
    outline: {
        offset: outlineOffset,
        style: 'solid',
        width: outlineWidth
    },
    popout: {
        default: defaultPopout,
        primary: primaryPopout
    },
    radio: {
        default: defaultRadioLight
    },
    shimmerLoader: {
        default: defaultLightShimmerLoader
    },
    switch: {
        default: defaultSwitchLight
    },
    table: {
        default: defaultTableLight
    },
    text: {
        default: BrandfolderHexColors.Text
    },
    tooltip: {
        danger: dangerTooltip,
        default: defaultTooltip,
        primary: primaryTooltip
    }
};
const darkTheme = {
    ...baseTheme,
    alert: {
        ...baseTheme.alert,
        error: errorAlertDark,
        none: defaultAlertDark,
        success: successAlertDark,
        warning: warningAlertDark
    },
    button: {
        ...baseTheme.button,
        default: whiteButton
    },
    darkMode: true,
    divider: {
        ...baseTheme.divider,
        default: defaultDividerDark,
        primary: primaryDividerDark
    },
    fieldset: {
        ...baseTheme.fieldset,
        default: defaultFieldsetDark
    },
    link: {
        outlineColorFocus: '#93a4e0',
        textColor: '#93a4e0',
        textColorActive: '#6c83d4',
        textColorDisabled: '#e2e7f7',
        textColorFocus: '#bbc6eb',
        textColorHover: '#bbc6eb',
        textColorVisited: '#93a4e0'
    },
    listbox: {
        ...baseTheme.listbox,
        default: defaultListboxDark
    },
    loader: {
        ...baseTheme.loader,
        primary: primaryDarkLoader
    },
    option: {
        ...baseTheme.option,
        default: defaultOptionDark
    },
    table: {
        ...baseTheme.table,
        default: defaultTableDark
    },
    text: {
        ...baseTheme.text,
        default: BrandfolderHexColors.White
    }
};
const lightTheme = {
    ...baseTheme,
    darkMode: false
};

export { darkTheme, lightTheme };
//# sourceMappingURL=themes.js.map
